import { render, staticRenderFns } from "./upImg.vue?vue&type=template&id=f3647392"
import script from "./upImg.vue?vue&type=script&lang=js"
export * from "./upImg.vue?vue&type=script&lang=js"
import style0 from "./upImg.vue?vue&type=style&index=0&id=f3647392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports